class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

/* Bloc 3 — code promo (drawer iCart natif) */
class CartDiscount extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.cart-discount__input');
    this.applyBtn = this.querySelector('.cart-discount__apply');
    this.applied = this.querySelector('.cart-discount__applied');
    if (!this.input || !this.applyBtn) return;
    const saved = sessionStorage.getItem('cart_discount_code') || '';
    if (saved) { this.input.value = saved; this.showApplied(saved); }
    this.applyBtn.addEventListener('click', () => this.apply());
    this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.apply(); } });
    this.wireCheckout();
  }
  apply() {
    const code = this.input.value.trim();
    if (code) { sessionStorage.setItem('cart_discount_code', code); this.showApplied(code); }
    else { sessionStorage.removeItem('cart_discount_code'); this.showApplied(''); }
    this.wireCheckout();
  }
  showApplied(code) {
    if (!this.applied) return;
    if (code) { this.applied.textContent = 'تم تطبيق الكود: ' + code; this.applied.hidden = false; }
    else { this.applied.hidden = true; }
  }
  wireCheckout() {
    const btn = document.querySelector('#cart button[name="checkout"]');
    if (!btn || btn.dataset.discountWired) return;
    btn.dataset.discountWired = '1';
    btn.addEventListener('click', (e) => {
      const code = sessionStorage.getItem('cart_discount_code');
      if (code) { e.preventDefault(); window.location.href = '/checkout?discount=' + encodeURIComponent(code); }
    });
  }
}
customElements.define('cart-discount', CartDiscount);

/* Bloc 4 — options cadeau (drawer iCart natif) */
class CartGiftOptions extends HTMLElement {
  connectedCallback() {
    this.miniCart = document.querySelector('mini-cart');
    this.querySelectorAll('.cart-gifts__check').forEach((cb) => {
      cb.addEventListener('change', () => this.toggle(cb));
    });
  }
  toggle(cb) {
    const variantId = cb.dataset.variantId;
    const qty = cb.checked ? 1 : 0;
    cb.disabled = true;
    const sections = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-live-region-text'];
    const body = JSON.stringify({ updates: { [variantId]: qty }, sections: sections, sections_url: window.location.pathname });
    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => { if (this.miniCart) this.miniCart.renderContents(state); })
      .catch((e) => { console.error(e); cb.disabled = false; });
  }
}
customElements.define('cart-gift-options', CartGiftOptions);

/* Bloc 5 — upsell (drawer iCart natif) */
class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.miniCart = document.querySelector('mini-cart');
    this.querySelectorAll('.cart-upsell__add').forEach((btn) => {
      btn.addEventListener('click', () => this.add(btn));
    });
  }
  add(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    const sections = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-live-region-text'];
    const body = JSON.stringify({ updates: { [variantId]: 1 }, sections: sections, sections_url: window.location.pathname });
    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => { if (this.miniCart) this.miniCart.renderContents(state); })
      .catch((e) => { console.error(e); btn.disabled = false; });
  }
}
customElements.define('cart-upsell', CartUpsell);
